<template>
  <v-container>
    <v-row dense>
      <v-col>
        <v-card flat>
              <v-card-title
                class="text-h5 d-flex justify-center my-3"
              >Scan QR</v-card-title>

              <v-card-subtitle class="text-center">
                <qrcode-stream :key="_uid" :track="this.paintOutline" @init="logErrors" />
                <br>
                <v-row dense>
                <v-col>
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                      v-model="QRID"
                      :rules="IDRules"
                      label="Device ID"
                      type="text"
                      prepend-icon="mdi-numeric"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="station"
                      :rules="nameRules"
                      label="Stasiun"
                      type="text"
                      prepend-icon="mdi-memory"
                      required
                    ></v-text-field>
                    <v-btn
                      class="float-right success"
                      rounded
                      @click="AddDevice(QRID,station,location,latitude,longitude)"
                    >
                      Save
                    </v-btn>
                  </v-form> 
                  </v-col>
                </v-row>
              </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  import { db } from '@/firebase/db.js'
  // import firebase from "firebase/compat/app"
  // import 'firebase/compat/auth';

  export default {
    name: 'AddDevice',

    data: () => ({
      QRID:null,
      station:null,
      valid: true,
      IDRules: [
        v => !!v || 'ID is Required',
        v => (v && v.length >=8) || 'ID must be at least 8 characters'
      ],
      nameRules: [
        v => !!v || 'This Field is required'
      ],
    }),
    methods: {
      paintOutline (detectedCodes, ctx) {
        for (const detectedCode of detectedCodes) {
          const [ firstPoint, ...otherPoints ] = detectedCode.cornerPoints
          this.QRID=detectedCode.rawValue;
          ctx.strokeStyle = "red";

          ctx.beginPath();
          ctx.moveTo(firstPoint.x, firstPoint.y);
          for (const { x, y } of otherPoints) {
            ctx.lineTo(x, y);
          }
          ctx.lineTo(firstPoint.x, firstPoint.y);
          ctx.closePath();
          ctx.stroke();
        }
      },

      logErrors (promise) {
        promise.catch(console.error)
      },

      async AddDevice(QRID,station) { 
        if (this.$refs.form.validate()) {
          let loader = this.$loading.show()
          var deviceRef = db.collection('radar').doc(QRID)
          await deviceRef.set({
            latitude:-6.8776407,
            longitude:107.5860216,
            station:station,
            location:'MARNOV',
            id: QRID,
            satuan: 'cm',
            password:'12345678'
          }).then(() => {
            loader.hide()
            this.$router.push('/')
          }).catch(() => {
            loader.hide()
            alert("Pendaftaran Gagal")
          })
        }
      }
    },
    watch: {
      location (val, prev) {
        val = val != null ? val : ''
        prev = prev != null ? prev : ''
        if (val.length === prev.length) return
        if (val!== '') {
          if (this.locations.indexOf(val)===-1) {
            this.locations.push(val)
            var locRef = db.collection('location')
            console.log(this.locations)
            locRef.doc('locations').set({
              locations:this.locations
            })
          }    
        }
      },
    }
  }
</script>
